/*
  CRAN. — Sticky add-to-cart (Partie 2 §7)
  N'implémente aucune logique panier propre : le clic proxy vers le
  vrai bouton "Ajouter au panier" de la page (celui du formulaire natif
  Dawn), pour ne jamais dupliquer/désynchroniser la gestion des
  variantes, du stock ou de l'AJAX panier déjà en place.
*/
(function () {
  var bar = document.querySelector('.cran-sticky-atc');
  if (!bar) {
    return;
  }

  var triggerId = bar.getAttribute('data-target-button');
  var triggerButton = triggerId ? document.getElementById(triggerId) : null;
  var ctaButton = bar.querySelector('.cran-sticky-atc__cta');

  if (ctaButton && triggerButton) {
    ctaButton.addEventListener('click', function () {
      triggerButton.click();
    });
  } else if (ctaButton) {
    ctaButton.disabled = true;
  }

  if (!triggerButton || !('IntersectionObserver' in window)) {
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      });
    },
    { threshold: 0 }
  );

  observer.observe(triggerButton);
})();
